import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  Dimensions,
  ActivityIndicator,
  Image,
  TouchableOpacity,
  ScrollView,
  Linking,
} from "react-native";
import { api } from "../api/api";
import {
  Link,
  useLocation,
  useNavigate,
  useNavigation,
  useParams,
} from "react-router-dom";
import { colors } from "../common/styles/colors";
import ImageColors from "react-native-image-colors";
// @ts-ignore
import LinearGradient from "react-native-web-linear-gradient";
import { getNearestGradientColors } from "../utils/PlaceCardGradientLib";
import { GRADIENT_ANGLE, PlaceCard } from "../components/PlaceCard";
import { FullPlaceType } from "../api/models/place";
import { fonts } from "../common/styles/fonts";
import { ArrowLeftWhite } from "../common/icons/ArrowLeftWhite";

export const PlacePage = ({ fromChat = false }: { fromChat?: boolean }) => {
  const { placeId } = useParams();

  const [isLoading, setIsLoading] = useState(false);

  const [place, setPlace] = useState<FullPlaceType | null>(null);

  const [gradientColor, setGradientColor] = useState<string[] | null>(null);

  const [error, setError] = useState<any>(null);

  useEffect(() => {
    if (placeId) {
      api.places
        .getPlace(placeId)
        .then((response) => {
          setPlace(response.data);
        })
        .catch((error) => {
          setError(error);
          console.log("error", error);
        })
        .finally(() => setIsLoading(false));
    }
  }, [placeId]);

  useEffect(() => {
    if (place) {
      ImageColors.getColors(place.picture_1, { fallback: colors.gray20 })
        .then((color: any) => getNearestGradientColors(color.dominant))
        .then((gradient: any) => setGradientColor(gradient))
        .catch((error) => {
          console.log("error", error);

          setGradientColor(["#1A1C19", "#B0B58F"]);
        });
    }
  }, [place]);

  const navigate = useNavigate();
  const { state } = useLocation();

  const backRoute = () => {
    if (state?.chatId) {
      navigate("/subscription/chat", { state: { chatId: state?.chatId } });
    } else {
      navigate(-1);
    }
  };

  return (
    <View
      style={{
        width: Dimensions.get("window").width,
        height: Dimensions.get("window").height,
        backgroundColor: colors.LightGrayishYellow,
      }}
    >
      {isLoading || (!error && !gradientColor) ? (
        <ActivityIndicator color={colors.black} style={{ flex: 1 }} />
      ) : error || !place ? (
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: colors.LightGrayishYellow,
          }}
        >
          <Text style={[fonts.largeText_bold, { color: colors.black }]}>
            Error
          </Text>
          <Text
            style={[
              fonts.mediumText_medium,
              { color: colors.black, textAlign: "center" },
            ]}
          >
            {error.message}
          </Text>
        </View>
      ) : (
        <LinearGradient
          useAngle
          angle={GRADIENT_ANGLE}
          style={{ height: "100%", alignItems: "center" }}
          colors={gradientColor}
        >
          {fromChat && (
            <TouchableOpacity
              onPress={backRoute}
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginVertical: 24,
                alignSelf: "flex-start",
                marginLeft: 32,
              }}
            >
              <ArrowLeftWhite style={{ marginRight: 4 }} />

              <Text style={[fonts.mediumText_regular, { color: colors.white }]}>
                back
              </Text>
            </TouchableOpacity>
          )}

          <ScrollView
            style={{ height: "100%" }}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{
              height: "100%",
              maxWidth: 370,
              paddingHorizontal: 36,
              paddingTop: 20,
              paddingBottom: 40,
            }}
          >
            <View style={{}}>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  alignSelf: "center",
                  marginBottom: 16,
                }}
              >
                <Image
                  resizeMode={"contain"}
                  style={{ width: 44, height: 49 }}
                  source={require("../common/images/gadderMascoute.png")}
                />
                <Image
                  resizeMode={"contain"}
                  style={{ width: 74, height: 30 }}
                  source={require("../common/images/gadderLogo.png")}
                />
              </View>

              <PlaceCard
                style={{
                  borderWidth: 2,
                  borderColor: "white",
                }}
                place={place}
              />
            </View>

            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                paddingTop: 24,
                paddingBottom: 32,
              }}
            >
              <TouchableOpacity
                onPress={() =>
                  Linking.openURL(
                    "https://apps.apple.com/gb/app/gadder/id1570036235"
                  )
                }
              >
                <Image
                  resizeMode={"contain"}
                  style={{ width: 140, height: 40 }}
                  source={require("../common/images/downloadIos.png")}
                />
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() =>
                  Linking.openURL(
                    "https://play.google.com/store/apps/details?id=com.fitme.ball"
                  )
                }
              >
                <Image
                  resizeMode={"contain"}
                  style={{ width: 140, height: 40 }}
                  source={require("../common/images/downloadAndroid.png")}
                />
              </TouchableOpacity>
            </View>
          </ScrollView>
        </LinearGradient>
      )}
    </View>
  );
};
